import { computed, onMounted, onUnmounted, ref, unref } from "vue"

export default function (mobileBreakpoint = 768, tabletBreakpoint = 1359) {
    const windowWidth = ref(window.innerWidth)

    const onWidthChange = () => windowWidth.value = window.innerWidth

    onMounted(() => {
        window.addEventListener('resize', onWidthChange)
    })

    onUnmounted(() => window.removeEventListener('resize', onWidthChange))

    const width = computed(() => windowWidth.value)
    const isMobile = computed(() => width.value <= unref(mobileBreakpoint))
    const isTablet = computed(() => width.value <= unref(tabletBreakpoint))

    return { width, isMobile, isTablet }
}
